var _require = require('./carousel'),
  carouselInit = _require.carouselInit;

// window function so that the customizer can call it as well on section updates
window.fetchProductRecommendationsSection = function (productRecommendationsSection) {
  var url = productRecommendationsSection.dataset.url;
  fetch(url).then(function (response) {
    return response.text();
  }).then(function (text) {
    var html = document.createElement('div');
    html.innerHTML = text;
    var recommendations = html.querySelector('.recommended-products__wrapper');
    if (recommendations && recommendations.innerHTML.trim().length) {
      productRecommendationsSection.innerHTML = recommendations.innerHTML;
      carouselInit();
    }
  })["catch"](function (e) {
    console.error(e);
  });
};
var handleIntersection = function handleIntersection(entries, observer) {
  if (!entries[0].isIntersecting) return;
  observer.unobserve(productRecommendationsSection);
  window.fetchProductRecommendationsSection(productRecommendationsSection);
};
var productRecommendationsSection = document.querySelector('.recommended-products__wrapper');
var observer = new IntersectionObserver(handleIntersection, {
  rootMargin: '0px 0px 200px 0px'
});
observer.observe(productRecommendationsSection);